export default __webpack_public_path__ + "static/media/symptoms.50573c03.PNG";